import expander from "./expander";

export default (function () {
  return {
    format(locationSelectorElm, responseText){
      const { Header, ShowInternationalCTA, BackToInternational, Regions, LocationsHeader, DifferentLocationHeader, ClosestLocationLabel, ReturnButtonLabel, ContinueButtonLabel } = responseText;

      const regionSectionHtml =
      `<section class="bg--white">
        <div class="wrapper wrapper--pad-l">
          <div class="regions">
            <h2 class="display-heading regions__heading h3">${Header}</h2>
            ${ShowInternationalCTA && BackToInternational!=null ? `<div class="location-selector__back u-align-center">
              <a href="/" class="btn btn--small btn--back btn--blue btn--icon btn--icon-globe"><span class="btn__text btn__text--arrow-back">${BackToInternational}</span></a>
            </div>` : ''}
            <ul class="regions__list bare-list js-last-line">
              ${Regions.map(region => `<li class="regions__item"><a href="#${region.Identifier}" class="regions__link js-expand-link" data-direction="open">${region.Name}</a></li>`).join("")}
            </ul>
          </div>
        </div>
      </section>`;

      const locationSection = `<div class="location-selector__countries">
      ${Regions.map(region => `
        <div id="${region.Identifier}">
          <section class="bg--lighter-grey bg--white-arrow">
            <div class="wrapper wrapper--pad-m">
              <div class="regions">
                <h2 class="regions__heading h5">${LocationsHeader}</h2>
                <ul class="regions__list bare-list js-last-line">
                ${region.Locations.map(loc => `<li class="regions__item"><a href="${loc.Url}" data-href="${loc.Url}" class="regions__link ${loc.ApplyOpCoAlert?'js-opco-warning':''}" data-name="${loc.Name}" data-country-id="${loc.Identifier}">${loc.Name}</a></li>`).join("")}
                </ul>
              </div>
            </div>
          </section>
        </div>`).join("")}
      </div>`;

      const closestLocationSection = `
      <div class="location-selector__closest js-closest-office u-hide">
        <section class="bg--med-blue bg--light-blue-arrow">
          <div class="wrapper wrapper--pad-m">
            <div class="closest-office">
              <p class="closest-office__intro">${ClosestLocationLabel} <strong class="closest-office__name u-uppercase js-closest-office-name">Colombia</strong></p>
              <p class="closest-office__links">
                <button class="text-link text-link--arrow-back js-location-close">${ReturnButtonLabel}</button>
                <a href="#" class="btn js-closest-office-link"><span class="btn__text btn__text--arrow">${ContinueButtonLabel} <span class="js-closest-office-name">Colombia</span></span></a>
              </p>
            </div>
          </div>
        </section>
      </div>`;

      locationSelectorElm.innerHTML = regionSectionHtml+locationSection+closestLocationSection;
      expander.init();
    }
  }
}());
